export default (v) => {
    // false and 0 are considered real values, and thus non-empty.
    return (
        v === undefined // Undefined
        || v === null // Null
        || v === '' // Empty String
        || (Array.isArray(v) && v.length === 0) // Empty Array
        || (Object.prototype.toString.call(v) === '[object Object]' && Object.keys(v).length === 0) // Empty Object
        || (typeof v === 'number' && isNaN(v)) // NaN
    );
};